import ToolbarButtonPopover from '../toolbar/ToolbarButtonPopover';
import ToolbarButton from '../toolbar/ToolbarButton';

import { useState, useEffect, useContext, type ReactNode } from "react";
import { SvgIconComponent } from '@mui/icons-material';

import { DrawingContext, DrawingFeatureType } from "../../contexts/DrawingContext";

const DrawingLayer = (
  id: string,
  name: string,
  icon: string | SvgIconComponent | ReactNode,
  drawingModeIn: string,
  drawingFeatureTypes: string[],
  buttonEnabled: () => boolean = () => true
) => {
  const [layerStyle, setLayerStyle] = useState<any>({
    id: id,
    type: "fill",
    paint: {
      'fill-color': "#AF0",
      'fill-opacity': 0.5
    }});
  const { coords, drawingMode, setDrawingMode, drawingFeatureType, setDrawingFeatureType, geojson, setGeojson } = useContext(DrawingContext);
  const [stale, setStale] = useState(false);

  useEffect(() => {
    let newGeojson: {} = {type: "FeatureCollection", features: []};
    if (drawingFeatureType === DrawingFeatureType.POLYGON) {
      newGeojson = {
          type: "FeatureCollection",
          features: [
            {
              type: "Feature",
              geometry: {
                type: "Polygon",
                coordinates: [coords],
              },
            },
          ],
      }
    }
    else if (drawingFeatureType === DrawingFeatureType.LINE) {
      newGeojson = {
          type: "FeatureCollection",
          features: [
            {
              type: "Feature",
              geometry: {
                type: "LineString",
                coordinates: coords,
              },
            },
          ],
      }
    }
    else if (drawingFeatureType === DrawingFeatureType.POINT) {
      newGeojson = {
          type: "FeatureCollection",
          features: [
            {
              type: "Feature",
              geometry: {
                type: "Point",
                coordinates: coords,
              },
            },
          ],
      }
    }
    setGeojson(newGeojson);
  }, [coords]);

  useEffect(() => {
    if (drawingFeatureType === DrawingFeatureType.POLYGON) {
      setLayerStyle({
        id: id,
        type: "fill",
        paint: {
          "fill-color": "#AF0",
          "fill-opacity": 0.5,
          "fill-outline-color": "#AF0"
        }
      });
    } else if (drawingFeatureType === DrawingFeatureType.LINE) {
      setLayerStyle({
        id: id,
        type: "line",
        paint: {
          "line-color": "#AF0",
          "line-width": 2
        }
      })
    } else if (drawingFeatureType === DrawingFeatureType.POINT) {
      setLayerStyle({
        id: id,
        type: "circle",
        paint: {
          "circle-color": "#AF0",
          "circle-radius": 5
        }
      })
    }
  }, [drawingFeatureType]);

  useEffect(() => {
    if (geojson) {
      setStale(true);
    }
  }, [geojson]);

  let toolbarButton;
  if (drawingFeatureTypes.length === 1) {
    const onlyType = drawingFeatureTypes[0];
    toolbarButton = (
      <ToolbarButton
        key={id}
        id={id}
        name={name}
        icon={icon}
        toggledOn={drawingMode === drawingModeIn}
        enabled={buttonEnabled()}
        onClick={() => {
          setDrawingMode(drawingModeIn);
          setDrawingFeatureType(onlyType);
        }}
      />
    );
  } else {
    const optionIcon = typeof icon === 'string' || typeof icon === 'function' ? icon : undefined;
    toolbarButton = (
      <ToolbarButtonPopover
        id={id}
        enabled={buttonEnabled()}
        name={name}
        toggledOn={drawingMode === drawingModeIn}
        icon={icon}
        labelSide={"right"}
        options={drawingFeatureTypes.map((featureType) => {
          return {
            id: id + featureType,
            label: 'Add ' + drawingModeIn + ' (' + featureType + ')',
            icon: optionIcon,
            onClick: () => {
              setDrawingMode(drawingModeIn);
              setDrawingFeatureType(featureType);
            },
          };
        })}
      />
    );
  }

  return {
    id: id,
    type: "drawing-layer",
    name: name,
    source: geojson,
    layerStyle: layerStyle,
    toolbarButton: toolbarButton,
    active: drawingMode === drawingModeIn,
    stale: stale,
    setStale: setStale
  };
};

export default DrawingLayer;
